<template>
  <div>代理排行榜</div>
</template>

<script>
export default {

}
</script>

<style>

</style>